import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import userManager from '../../../helpers/userManager';
import { Container, Title, RedirectMessage } from './login-redirect.style';

/**
 * Login redirect component. Handles redirecting user
 * back to the application after they logged in.
 * @return {element} - Login redirect view
 */
const LoginRedirect = () => {
  const isLoadingUser = useSelector((state) => state.oidc.isLoadingUser);
  const currentLocation = useLocation();

  useEffect(() => {
    if (!isLoadingUser) {
      // TODO: remove once Identity Server supports redirecting to linked URLs
      sessionStorage.setItem('linkedUrl', JSON.stringify(currentLocation));

      const loginTimeout = setTimeout(() => userManager.signinRedirect(), 1500);
      return () => clearTimeout(loginTimeout);
    }
    return undefined;
  }, [isLoadingUser, currentLocation]);

  return (
    <Container>
      <Title>Track &amp; Trace</Title>
      <RedirectMessage>Redirecting you to the login page...</RedirectMessage>
    </Container>
  );
};

export default LoginRedirect;
